//./core/bus/EventBus.ts
type Handler<T = any> = (payload: T) => void;
type UnsubscribeFunction = () => void;

class EventBus {
  private constructor() {}
  private static instance: EventBus;
  public static getInstance(): EventBus {
    if (!EventBus.instance) {
      EventBus.instance = new EventBus();
    }
    return EventBus.instance;
  }
  private map = new Map<string, Set<Handler>>();

  on<T = any>(type: string, fn: Handler<T>): UnsubscribeFunction {
    if (!this.map.has(type)) this.map.set(type, new Set());
    this.map.get(type)!.add(fn as Handler);
    return () => this.off(type, fn);
  }

  off<T = any>(type: string, fn: Handler<T>) {
    this.map.get(type)?.delete(fn as Handler);
  }

  emit<T = any>(type: string, payload?: T) {
    this.map.get(type)?.forEach(fn => fn(payload));
  }

  unsubscribeAll(type: string) {
    this.map.delete(type);
  }

  clear() {
    this.map.clear();
  }
}
export const GlobalBus = EventBus.getInstance();

/** Close open popups/modals so a blocking system overlay (e.g. connection failed) is visible. */
export const UI_DISMISS_POPUPS = 'ui:dismiss-popups';
